import req from 'utils/req';
import memoize from 'lodash.memoize';
import { isCordova } from 'utils/platform';
import Pusher from 'pusher-js';

const authEndpoint = `${URL_API_HOST}/api/v2/pusher/authenticate`;

const authorizer = (channel: any) => {
  return {
    authorize(socketId: string, callback: (b: boolean, a: any) => void) {
      req(authEndpoint)
        .post({ channel_name: channel.name, socket_id: socketId })
        .then(authInformation => callback(false, authInformation));
    },
  };
};

const initializePusher = memoize(() => {
  const socket = new Pusher(PUSHER_APP, {
    authEndpoint,
    authorizer,
    encrypted: true,
    ignoreNullOrigin: isCordova(),
    cluster: PUSHER_CLUSTER,
  });

  socket.connection.bind('disconnected', () => { console.log('[Pusher] connection closed'); });
  socket.connection.bind('connected', () => { console.log('[Pusher] connection established'); });
  return socket;
});

export default initializePusher;
